<template>
    <div>
        <div class="tab-top">
            <h2>{{ $t('digital.tabs.landlord.headline') }}</h2>
            <p>{{ $t('digital.tabs.landlord.text') }}</p>
        </div>
        <div class="seperator"></div>
        <div class="wizard-component data-input">
            <p class="subject">{{ $t('digital.tabs.onbehalf-label') }}</p>
            <div class="double-radio">
                <label for="isCreatedByAgentYesInput" class="custom-radio">
                    <input id="isCreatedByAgentYesInput" type="radio" :value="true"
                           v-model="value.is_created_by_broker"/>
                    <span class="radio-circle"></span>
                    <p>{{ $t('general.label.yes') }}</p>
                </label>
                <label for="isCreatedByAgentNoInput" class="custom-radio">
                    <input id="isCreatedByAgentNoInput" type="radio" :value="false"
                           v-model="value.is_created_by_broker"/>
                    <span class="radio-circle"></span>
                    <p>{{ $t('general.label.no') }}</p>
                </label>
            </div>
        </div>

        <div class="wizard-component data-input" v-if="value.is_created_by_broker === true">
            <p class="subject">{{ $t('digital.tabs.signing-landlord') }}</p>
            <div class="double-radio">
                <label for="requiresLandlordApprovalYesInput" class="custom-radio">
                    <input id="requiresLandlordApprovalYesInput" type="radio" :value="true"
                           v-model="value.requires_landlord_approval"/>
                    <span class="radio-circle"></span>
                    <p>{{ $t('general.label.yes') }}</p>
                </label>
                <label for="requiresLandlordApprovalNoInput" class="custom-radio">
                    <input id="requiresLandlordApprovalNoInput" type="radio" :value="false"
                           v-model="value.requires_landlord_approval"/>
                    <span class="radio-circle"></span>
                    <p>{{ $t('general.label.no') }}</p>
                </label>
            </div>
        </div>

        <div class="seperator"></div>
        <div class="wizard-component data-input">
            <div class="inputs">
                <div class="input-container">
                    <p class="subject">{{ $t('input.placeholder.email') }}</p>
                    <form>
                        <input type="text" v-model="value.landlord_email"
                               :disabled="value.is_created_by_broker === false"/>
                    </form>
                </div>
            </div>
        </div>

        <div class="seperator"></div>
        <button v-on:click="save()" class="purple next-btn" :disabled="state === 'saving'">
            {{ $t('digital.tabs.nextstep') }}
        </button>
    </div>
</template>

<script>
import SvgIcon from "../../../components/Svg";
import {mapGetters} from "vuex";

export default {
    name: "CustomContractLandlord",
    props: ['value', 'state'],
    components: {
        SvgIcon
    },
    computed: {
        ...mapGetters(['getEmail'])
    },
    methods: {
        save() {
            this.$emit('saving');

            if (this.value.is_created_by_broker === false) {
                this.value.landlord_email = this.getEmail;
            }

            axios({
                method: 'PATCH',
                url: `${window.config.apiUrl}api/custom-contract/${this.value.id}`,
                cancelToken: window.AuthorizationCancelSource.token,
                data: _.pick(this.value, ['is_created_by_broker', 'requires_landlord_approval', 'landlord_email'])
            }).then(response => {
                Object.assign(this.value, response.data.data);
                this.$store.commit('setSuccessBarMessage', this.$t('successbar.label.landlord-saved'));
                this.$emit('input', this.value);
                this.$emit('save');
            }).catch((e) => {
                this.$emit('error', e);
            });
        }
    },
    watch: {
        value: {
            // This will let Vue know to look inside the array
            deep: true,

            // We have to move our method to a handler field
            handler() {
                if (this.value.is_created_by_broker === false) {
                    this.value.landlord_email = this.getEmail;
                }
            }
        }
    },
}
</script>

<style lang="scss" scoped>

input:disabled {
    background-color: #efefef !important;
}

</style>
